export const iconFontAwesomeCampingCampground = (
	<i className="fa-solid fa-campground"></i>
);
